// components/layout/AppShell.jsx
import { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useRouter } from "../../contexts/RouterContext";
import PageRenderer from "./PageRenderer";
import { getBranding } from "../../utils/branding";

const NAV_ITEMS = [
  { id: "dashboard", icon: "🏠", label: "Dashboard" },
  { id: "customers", icon: "👥", label: "Customers" },
  { id: "karigars",  icon: "🧵", label: "Karigars" },
  { id: "orders",    icon: "📋", label: "Orders" },
  { id: "payments",  icon: "💳", label: "Payment" },
  { id: "receipts",  icon: "🧾", label: "Receipt" },
  { id: "reports",   icon: "📊", label: "Reports" },
  { id: "settings",  icon: "⚙️", label: "Settings" },
];

// Which top-level nav item to highlight for each route page
const NAV_ACTIVE_MAP = {
  dashboard:         "dashboard",
  customers:         "customers",
  "customer-add":    "customers",
  "customer-edit":   "customers",
  "customer-detail": "customers",
  karigars:          "karigars",
  "karigar-add":     "karigars",
  "karigar-edit":    "karigars",
  orders:            "orders",
  "order-create":    "orders",
  "order-edit":      "orders",
  "order-detail":    "orders",
  payments:          "payments",
  receipts:          "receipts",
  reports:           "reports",
  settings:          "settings",
  profile:           "profile",
};

const PAGE_TITLES = {
  dashboard:         "Dashboard",
  customers:         "Customers",
  "customer-add":    "Add Customer",
  "customer-edit":   "Edit Customer",
  "customer-detail": "Customer Profile",
  karigars:          "Karigars",
  "karigar-add":     "Add Karigar",
  "karigar-edit":    "Edit Karigar",
  orders:            "Orders",
  "order-create":    "Create Order",
  "order-edit":      "Edit Order",
  "order-detail":    "Order Details",
  payments:          "Payments",
  receipts:          "Receipts",
  reports:           "Reports",
  settings:          "Settings",
  profile:           "Company Profile",
};

export default function AppShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { company, logout } = useAuth();
  const { route, navigate } = useRouter();

  const activeNav  = NAV_ACTIVE_MAP[route.page] || "dashboard";
  const pageTitle  = PAGE_TITLES[route.page]    || "TailorExpert";
  const brand      = getBranding(company);

  return (
    <div className="app-shell">
      {/* ── Sidebar ── */}
      <nav className={`sidebar${sidebarOpen ? " open" : ""}`}>
        <div className="sidebar-logo">
           
          <div className="sidebar-logo-icon">
             <img src='/assets/logo.png' alt="logo" height={40}/>
          </div>
          <div>
            <div className="sidebar-logo-text">TailorExpert</div>
            <div className="sidebar-logo-sub">Order Management</div>
          </div>
        </div>

        <div className="sidebar-nav">
          <div className="sidebar-section">Navigation</div>
          {NAV_ITEMS.map((item) => (
            <div
              key={item.id}
              className={`nav-item${activeNav === item.id ? " active" : ""}`}
              onClick={() => { navigate(item.id); setSidebarOpen(false); }}
            >
              <span className="nav-icon">{item.icon}</span>
              {item.label}
            </div>
          ))}
        </div>

        <div className="sidebar-footer">
          <div className="sidebar-user-label">Shop</div>
          <div className="sidebar-user-email" style={{fontWeight:600,color:"var(--text)",marginBottom:2}}>{company?.CM_Name ?? ""}</div>
          <div className="sidebar-user-email">{company?.CM_Email ?? ""}</div>
          <button
            className="btn btn-ghost btn-full"
            style={{ justifyContent: "center", fontSize: 12.5 }}
            onClick={logout}
          >
            ⏏ Sign Out
          </button>
        </div>
      </nav>

      {/* ── Main Content ── */}
      <div className="main-content">
        <header className="topbar">
          <div className="topbar-left">
            {/* Mobile hamburger */}
            <button
              className="mobile-menu-btn"
              style={{ background: "none", border: "none", color: "var(--text)", fontSize: 20, cursor: "pointer", padding: "4px 6px", borderRadius: 6 }}
              onClick={() => setSidebarOpen(!sidebarOpen)}
              aria-label="Toggle sidebar"
            >
              ☰
            </button>
            {/* <h1 className="topbar-title">{pageTitle}</h1> */}
          </div>

          <div className="topbar-right">
            <div
              className="user-pill"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("profile")}
              title="Company profile"
            >
              <div className="user-avatar">
                {brand.profilePic
                  ? <img src={brand.profilePic} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }} />
                  : (company?.CM_Name ?? "S")[0].toUpperCase()}
              </div>
              <span className="user-name">{company?.CM_Name ?? "Shop"}</span>
            </div>
          </div>
        </header>

        <PageRenderer />
      </div>

      {/* Mobile backdrop */}
      {sidebarOpen && (
        <div
          style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 99 }}
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  );
}
